module.exports = __webpack_public_path__ + "assets/img/bind9.24b36b7b.png";